module.exports = __webpack_public_path__ + "3033e615ecf8c77c41291b66479133ff.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-54.svg
// module id = 584
// module chunks = 0